





































import {
    Component,
    Prop,
    Vue,
    Watch,
} from 'vue-property-decorator';
import Icon from '@/components/Icon.vue';
import { PermissionIssue } from '@/core/userinfo';

@Component({
    components: { Icon },
})
export default class PermissionAlert extends Vue {
    @Prop({ type: Array, default: () => [] }) readonly issues!: PermissionIssue[];

    @Prop(String) readonly domain!: string;

    dismissed = false;

    get storageKey(): string {
        return `permissionAlertDismissed:${this.domain}`;
    }

    @Watch('domain', { immediate: true })
    onDomainChanged(): void {
        this.dismissed = sessionStorage.getItem(this.storageKey) === '1';
    }

    dismiss(): void {
        sessionStorage.setItem(this.storageKey, '1');
        this.dismissed = true;
    }
}
